import store from '@/store/store'

// @ts-ignore
import BazingaTranslator from 'bazinga-translator'
import config from '@/assets/translations/config.json'
import messages from '@/assets/translations/all.json'

BazingaTranslator.fromJSON(config)
BazingaTranslator.fromJSON(messages)

// @ts-ignore
if (!window.Translator) {
    // @ts-ignore
    window.Translator = BazingaTranslator
}

export function trans(key: string, namespace = 'messages', params: any = {}, choice?: number, lang?: string) {
    if (choice !== undefined && choice !== null) {
        // @ts-ignore
        return (
            window.Translator?.transChoice?.(key, choice, params, namespace, lang || store.getters['user/getLocale']) ||
            key
        )
    } else {
        // @ts-ignore
        return window.Translator?.trans?.(key, params, namespace, lang || store.getters['user/getLocale']) || key
    }
}

export default {
    install(Vue: any) {
        Vue.filter('trans', (key: string, namespace = 'messages', params: any = {}, choice?: number, lang?: string) => {
            if (choice !== undefined && choice !== null) {
                // @ts-ignore
                return (
                    window.Translator?.transChoice?.(
                        key,
                        choice,
                        params,
                        namespace,
                        lang || store.getters['user/getLocale']
                    ) || key
                )
            } else {
                // @ts-ignore
                return (
                    window.Translator?.trans?.(key, params, namespace, lang || store.getters['user/getLocale']) || key
                )
            }
        })

        Vue.prototype.$trans = trans
    },
}
